/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ion-slides[_ngcontent-%COMP%]{height:100%}.toolbar-background[_ngcontent-%COMP%]{background:var(--ion-color-primary)!important;border-color:transparent}.slide-zoom[_ngcontent-%COMP%]{height:99vh}.slide-title[_ngcontent-%COMP%]{margin-top:0}.slide-image[_ngcontent-%COMP%]{max-width:128px!important;margin:0 0 18px}.toastclass[_ngcontent-%COMP%]{transform:translateY(70px)!important}"];
export { styles as styles };
